import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExportStockCheckExcel = (productsList) => {
  if (!productsList || productsList.length === 0) return;

  // Prepare the worksheet data
  const worksheetData = productsList.map((item, index) => ({
    "S.No": index + 1,
    "Item Name": item.name,
    Category: item.category,
    Quantity: item.qty,
    Unit: item.unit,
    Price: Math.round((+item.amount || 0) * 100) / 100,
    Total: Math.round(((+item.qty || 0) * (+item.amount || 0)) * 100) / 100,
    Status: item.isActive,
  }));

  // Add total row
  worksheetData.push({});
  const totalAmount = productsList.reduce(
    (sum, item) => sum + item.qty * item.amount,
    0
  );

  worksheetData.push({
    "Item Name": "Total",
    Total: `$${totalAmount.toFixed(2)}`,
  });

  // Create worksheet and workbook
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Check");

  // Export to file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const fileData = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(fileData, "StockCheckReport.xlsx");
};

export default ExportStockCheckExcel;
